import { Component, EventEmitter, Output } from '@angular/core';
import { LibraryItemHeaderComponent } from '../../../Common/library-item-header/library-item-header.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { LIBRARY_TABS } from '../../../../models/enum';

@Component({
  selector: 'app-library-view',
  imports: [
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    LibraryItemHeaderComponent,
    TranslatePipe
  ],
  templateUrl: './library-view.component.html',
  styleUrl: './library-view.component.scss'
})
export class LibraryViewComponent {

  @Output() unpinLibraryView = new EventEmitter<LIBRARY_TABS>();
  @Output() closeLibraryView = new EventEmitter<LIBRARY_TABS>();

  constructor() { }

  unpinLibrary() {
    this.unpinLibraryView.emit(LIBRARY_TABS.LibraryView);
  }

  closeLibrary() {
    this.closeLibraryView.emit(LIBRARY_TABS.LibraryView);
  }

}
